import { Route } from 'react-router';
import HelpCenterLayout from '../contexts/shared/components/layouts/HelpCenterLayout'
import Home from '../contexts/frontoffice/helpcenter/ui/pages/Home'
import ContactForm from '../contexts/frontoffice/helpcenter/ui/pages/ContactForm'
import Section from '../contexts/frontoffice/helpcenter/ui/pages/Section'
import SectionDetail from '../contexts/frontoffice/helpcenter/ui/pages/SectionDetail'
import SectionStart from '../contexts/frontoffice/helpcenter/ui/pages/SectionStart'
import SectionStartQuestion from '../contexts/frontoffice/helpcenter/ui/pages/SectionStartQuestion'
import NotFound from '../contexts/shared/pages/NotFound'

export const HelpCenterRoutes = (
  <Route path="/ayuda" element={<HelpCenterLayout />}>
    <Route index element={<Home />} />
    <Route path="contacto" element={<ContactForm />} />
    <Route path="tutoriales/:type" element={<Section />} />
    <Route path="tutoriales/:type/:section/:questionid" element={<SectionDetail />} />
    <Route path="comoempezar" element={<SectionStart />} />
    <Route path="comoempezar/info/:section/:questionid" element={<SectionStartQuestion />} />
    <Route path="*" element={<NotFound />} />
  </Route>
);
